export const FETCH_ROLES = '@@role/fetch-roles';
export const FETCH_ROLES_SUCCESS = '@@role/fetch-roles-success';
export const FETCH_ROLES_FAILURE = '@@role/fetch-roles-failure';
export const ADD_ROLE = '@@role/add-role';
export const ADD_ROLE_SUCCESS = '@@role/add-role-success';
export const ADD_ROLE_FAILURE = '@@role/add-role-failure';
